import {
  api,
  apiActionDispatcher,
  apiCall,
  byIdResponseHandler,
  signalRWrappedApiCall
} from '../actions/api';
import { subscriptionTypes, signalRHubManager } from './signalRHub/signalRHubManager';
import * as types from './types';
import {
  dispatchersReducer,
  jobBuildsReducer
} from '../reducers';
import Moment from 'moment';
import { flatten, keys, uniq } from 'lodash';
import { toastr } from 'react-redux-toastr';
import { messaging } from '../helpers';

const fetchDispatchersByTypeDispatcher = (type) => apiActionDispatcher({
  actionTypes: types.dispatchersActionTypes,
  responseHandler: response => {
    if (response.length === 0) {
      toastr.warning(messaging.NO_DATA_AVAILABLE + ' for ' + type);
    }
    return byIdResponseHandler(response);
  }
});

const fetchDispatchersDispatcher = apiActionDispatcher({
  actionTypes: types.dispatchersActionTypes,
  responseHandler: response => {
    if (response.length === 0)
      toastr.warning(messaging.NO_DATA_AVAILABLE);
    return byIdResponseHandler(response);
  }
});

const fetchDispatcherOnDemandDispatcher = apiActionDispatcher({
  actionTypes: types.dispatchersActionTypes,
  responseHandler: response => byIdResponseHandler([response])
});

export const fetchDispatchers = () => signalRWrappedApiCall(
  apiCall(
    fetchDispatchersDispatcher,
    api.dispatcher.fetchAll,
    state => {
      const dispatchers = dispatchersReducer.getDispatchers(state);
      const firstDispatcherId = dispatchers && Object.keys(dispatchers)[0];
      return dispatchers && dispatchers.length > 0 &&
        dispatchers[firstDispatcherId].id === 1;
    },
    null,
    state => state.dispatchers.request
  ),
  fetchDispatchersDispatcher,
  signalRHubManager,
  subscriptionTypes.dispatchers
);

export const fetchRecentDispatchers = (days) => signalRWrappedApiCall(
  apiCall(
    fetchDispatchersDispatcher,
    api.dispatcher.fetchRecent,
    state => {
      const today = Moment();
      const dispatchers = dispatchersReducer.getDispatchers(state);
      const dispathcerNonJobDetail = dispatchers.filter(d => !d.job);
      if (dispathcerNonJobDetail.length !== 0)
      {
        return false;
      }
      const latestDispatcher = dispatchers.length !== 0 &&
        dispatchers[dispatchers.length - 1];
      const earliestDispatcher = dispatchers.length !== 0 &&
      dispatchers[0];
      return dispatchers && dispatchers.length > 0 &&
        today.diff(
          Moment(latestDispatcher.created_at), 'days') === 0 &&
          today.diff(
            Moment(earliestDispatcher.created_at), 'days') === days;
    },
    null,
    state => state.dispatchers.request,
    null,
    [days]
  ),
  fetchDispatchersDispatcher,
  signalRHubManager,
  subscriptionTypes.dispatchers
);

export const fetchRecentDispatchersByType = (type, days) => signalRWrappedApiCall(
  apiCall(
    fetchDispatchersByTypeDispatcher(type),
    api.dispatcher.fetchRecentByType,
    state => {
      const dispatchers = dispatchersReducer.cachedDispatchersByType(state, type) || [];
      const dispatchersNonSummary = dispatchers.filter(d => !d.scenarios_summary);
      const dispathcerNonJobDetail = dispatchers.filter(d => !d.job);
      if (dispatchersNonSummary.length === 0 || dispathcerNonJobDetail.length !== 0)
      {
        return false;
      }
      const earliestDispatcher = dispatchers[dispatchers.length - 1];
      if (earliestDispatcher)
      {
        const timestamp = Moment().startOf('day').subtract(days, 'days').unix();
        const givenDay = Moment(timestamp);
        return givenDay.diff(Moment(earliestDispatcher.created_at), 'days') < 0;
      }
      return false;
    },
    null,
    state => state.dispatchers.request,
    null,
    [type, days]
  ),
  fetchDispatchersByTypeDispatcher(type),
  signalRHubManager,
  subscriptionTypes.dispatchers
);

export const fetchDispatchersByBuildIds = (buildIds) => signalRWrappedApiCall(
  apiCall(
    fetchDispatchersDispatcher,
    api.dispatcher.fetchDispatchersByBuildIds,
    state => {
      if (buildIds.length === 0)
      {
        return true;
      }
      let jobsGroupedByBuilds = buildIds.map(buildId =>
        jobBuildsReducer.jobIdsByBuildId(state)[buildId] || []);
      jobsGroupedByBuilds = jobsGroupedByBuilds.filter(g => g.length > 0);
      if (jobsGroupedByBuilds.length !== buildIds.length)
      {
        return false;
      }

      const jobIds = uniq(flatten(jobsGroupedByBuilds));

      if (jobIds.length === 0)
      {
        return false;
      }

      const dispatchers = dispatchersReducer.getDispatchers(state);
      const dispatchersByJobIds = dispatchers.filter(d => jobIds.includes(d.job_id));
      const filteredDispatcher = dispatchersByJobIds.filter(
        d => d.scenarios_summary && keys(d.scenarios_summary).length > 0);
      return filteredDispatcher.length === dispatchersByJobIds.length;
    },
    null,
    null,
    [buildIds]
  ),
  fetchDispatchersDispatcher,
  signalRHubManager,
  subscriptionTypes.dispatchers
);

export const fetchDispatcherByJobId = (jobId) =>
  apiCall(
    fetchDispatcherOnDemandDispatcher,
    api.dispatcher.fetchDispatcherByJobId,
    state => dispatchersReducer.getDispatchersByJobId(state, jobId),
    null,
    null,
    [jobId]
  );

export const fetchDispatcherByNameAndNumber = (jobNameNumber) =>
  apiCall(
    fetchDispatcherOnDemandDispatcher,
    api.dispatcher.fetchDispatcherByNameAndNumber,
    state => dispatchersReducer.getJobIdByDispatcherNameNumber(state, jobNameNumber),
    null,
    null,
    [jobNameNumber]
  );


// WEBPACK FOOTER //
// src/actions/dispatchers.js